export default function formatID(idString) {
  return idString.replace(/\s+/g, '-');
}
